<template>
	<el-autocomplete v-model="name" clearable :fetch-suggestions="querySearchAsync" style="min-width: 250px;width: 100%;" :placeholder="placeholder">
	</el-autocomplete>
</template>

<script>
	import {
		POST_ENTITY,
	} from '@/api/api.commons.js'

	export default {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			access_token: {
				type: String,
				default () {
					return undefined
				}
			},
			value: {
				type: String,
				default () {
					return ''
				}
			},
			placeholder: {
				type: String,
				default() {
					return '请输入内容'
				}
			},
			resource: String,
			field: String,
			limit: {
				type: Number,
				default () {
					return 10
				}
			},
			sort: {
				type: String,
				default () {
					return 'ASC'
				}
			},
		},
		data() {
			return {
				name: ''
			}
		},
		created() {
			this.name = this.value
		},
		watch: {
			value(val) {
				this.name = val
			},
			name(val) {
				this.$emit("change", val)
			}
		},
		methods: {
			querySearchAsync(search, cb) {
				const params = this.access_token === undefined ? {} : {access_token: this.access_token}
				POST_ENTITY({
					uri: '/valueModules/query',
					data: {
						resource: {
							id: this.resource
						},
						x: this.field,
						sortX: this.sort,
						limit: this.limit,
						fieldGroups: JSON.stringify({
							"fieldGroupType": "and",
							"conditions": [{
								"fieldGroupType": "and",
								"conditions": [{
									"field": this.field,
									"condition": "contains",
									"value": search
								}]
							}]
						})
					},
					params
				}).then(({
					columns: [column],
					rows
				}) => {
					cb(!rows ? [] : rows.map(item => {
						return {
							value: item[column]
						}
					}))
				})
			}
		}
	}
</script>
